import locale from "localization";
export const checkIfObjectValuesAreEqual = (obj1, obj2) => {
  // sorting of keys must match, else this will not work
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const sortByKeyName = (key, string = true) => {
  return (a, b) => {
    if (a && b && a[key] && b[key]) {
      const first = string && a[key] ? a[key].toString().toLowerCase() : a[key];
      const second = string && b[key] ? b[key].toString().toLowerCase() : b[key];
      if (first < second) return -1;

      if (first > second) return 1;
    }

    return 0;
  };
};

export const parseCSVFile = async (file, columns = []) => {
  const fileContent = await file?.text();
  const rows = fileContent.split("\n");
  const errors = [];
  const rowErrors = [];
  const errorType = {};
  let allVouchers = [];
  let hasBlankRows = false;
  let hasValue = false;
  let invalidFormat = false;
  let hasDuplicateVoucher = false; //special case for third party voucher
  const items = rows
    .reverse()
    .filter((row) => {
      if (!row.replaceAll(",", "").trim() && !hasValue) {
        return false;
      }
      hasValue = true;
      return true;
    })
    .reverse()
    .filter((row, index) => {
      const r = row.replaceAll("\r", "").split(",");
      if (index === 0) {
        r.forEach((text, i) => {
          const row = i + 1;
          const columnText = columns[i]?.text;
          const isValid = text === columnText;
          if (!isValid) {
            invalidFormat = true;
            errors.push(`Column ${row} should be '${columnText}'`);
            rowErrors.push(`Invalid header at Column ${row}`);
          }
        });
      }
      return index !== 0;
    })
    .map((row, index, array) => {
      const r = row.replaceAll("\r", "").split(",");
      const obj = {};
      if (!r.length) {
        hasBlankRows = true;
      }

      r.forEach((text, i) => {
        obj[columns[i]?.key] = text;
      });

      // let allVouchers = [];
      // rows.forEach((item, index) => {
      //   const r = item.replaceAll("\r", "").split(",");
      //   r.forEach((text, i) => {
      //     if (columns[i]?.key === locale.thirdPartyKey) {
      //       if (text !== locale.thirdPartyVoucherCode) {
      //         allVouchers.push(text);
      //       }
      //     }
      //   });
      // });

      const messages = [];

      r.forEach((text, i) => {
        if (!text.trim()) {
          hasBlankRows = true;
        }

        if (columns[i]?.key === locale.thirdPartyKey) {
          if (text !== locale.thirdPartyVoucherCode) {
            if (allVouchers.find((o) => o.value === text)) {
              hasDuplicateVoucher = true;
              messages.push(locale.thirdPartyVoucherCodesExist);
            } else {
              allVouchers.push({
                value: text,
              });
            }
          }
        }
        const row = index + 2;

        if (columns[i]?.validation) {
          const errorStatus = columns[i]?.validation(text, obj);
          if (errorStatus.error) {
            if (!messages.includes(errorStatus.message)) {
              messages.push(errorStatus.message);
            }
            if (errorStatus.errorType) {
              if (
                !errorType[errorStatus.errorType] ||
                !errorType[errorStatus.errorType].includes(row)
              ) {
                errorType[errorStatus.errorType] = errorType[errorStatus.errorType]
                  ? [...errorType[errorStatus.errorType], row]
                  : [row];
              }
            }
          }
        }
      });
      if (messages.length) {
        errors.push(`Row ${index + 2}: ${messages.join(", ")}`);
        rowErrors.push(index + 2);
        obj.error = true;
      }
      return { ...obj, rowNumber: index + 1 };
    });
  return {
    items,
    passed: items.filter((item) => !item.error),
    errors,
    rowErrors,
    errorType,
    hasBlankRows,
    invalidFormat,
    hasDuplicateVoucher,
  };
};

export const mapOptions = (values = [], prettifier = () => {}) => {
  return [
    ...values.map((value) => ({
      label: prettifier(value),
      value,
    })),
  ];
};

export const exportCSV = ({ rows, filename }) => {
  const csvContent = "data:text/csv;charset=utf-8," + rows.join("\n");
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `${filename}.csv`);
  document.body.appendChild(link);

  link.click();
};

export const sortProductsBySku = (products, key = "sku") => {
  if (!products) return [];

  return products?.sort((a, b) => {
    const regex = /^(diesel|gas\d{2})/;
    return regex.test(b[key]) - regex.test(a[key]) || a[key].localeCompare(b[key]);
  });
};
